<template>
	<section>
		<div class="bg-transition">
			<div class="ovale"></div><div class="ovale"></div><div class="bloc"></div>
		</div>
		<div class="container">
			
				<slot></slot>
				<div :class="['grid',nbrArticle(articles)]">
		
				<article class="article shadow" v-for="article in articles">
					<a :href="article.url">
						<div class="cover" :style="{backgroundImage:'url('+article.cover+')'}"></div>
	
						<h2 class="ls-2 f-anti fw-bold">{{article.title }}</h2>
						<p class="author fs-12 f-anti ls-2">{{article.date_author}}</p>
					</a>
				</article>
				<article class="ghost" v-for="n in (7 - articles.length)"></article>
		</div>
		</div>
		
	</section>
</template>

<script>
	export default{
		props: ['articles'],
		methods : {
			nbrArticle(list){
				if(list.length <= 7){
					if(list.length == 4){
						return 'grid-4';
					} else if(list.length == 3) {
						return 'grid-3';
					} else {
						return 'grid-7';
					}	
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	
	.bg-transition {
		height: 10vw;
		width: 100vw;
		background:#f8f8f8;
		position: absolute;
		overflow:hidden;
		margin: 0;
		left: 0;
		top: 0; 

		@media ($tablet_portrait){
			background:#efefef;
		}

		.ovale {
			position: absolute;
			background: #f0f0f0;
			width: 90vw;
			height: 9vw;
			top: -3.1vw;
			border-radius: 45vw / 4.5vw;
			left: -22.25vw;

			@media ($tablet_portrait){
				background:#e8e8e8;
			}	
			
		}
		.ovale + .ovale {
			left: auto;
			right: -22.25vw;
			top: auto;
			background: #f8f8f8;
			bottom: -3.1vw;
			z-index: 10;

			@media ($tablet_portrait){
				background:#efefef;
			}	
		}
		.bloc {
			width: 100%;
			background: #f0f0f0;
			height: 5vw;
			z-index: 1;
			top: 0;
			left: 0;
			position: absolute;
			@media ($tablet_portrait){
				background:#e8e8e8;
			}	
		}
	}

	section {
		background: #f8f8f8;
		z-index: 100;
		width: 100vw;
		position: relative;
		padding-top: calc(10vw + 20px);
		margin-bottom: 120px;
		@media ($tablet_portrait){
			background:#efefef;
		}
	}

	section .container {
		
		width: calc(1200px + 56px);
		position: relative;
		margin: 0 auto;
		h1 {
			text-align: center;
		}

		@media ($desktop_only) {
        	width: calc(100vw - 80px);
    	}

		@media ($tablet_paysage){
			width: 100%;
		}
	}

	.grid {
		display: flex;
		align-items: stretch;
		flex-wrap : wrap;
		justify-content: space-between;

		@media ($tablet_paysage){
			overflow: scroll;
			flex-wrap: no-wrap;
			width: 95%;
			margin-left: 2.5%;
			margin-right: 2.5%;
		}


		&.grid-7 {
			.article, .ghost {
				width: 291px;
				h2 {
					font-size: 17px;
					line-height: 22px;
				}
				@media ($desktop_only) {
        			width: calc(25% - 20px);
    			}
			}
			.article:nth-child(1),
			.article:nth-child(2),
			.article:nth-child(3) {
				h2 {
					font-size: 20px;
					line-height: 26px;
					max-height: none;
    				overflow: visible;
    				margin: 25px 30px;
				}
				.author {
					font-size: 13px;
				}	
				.cover {
					padding-top: 49%;
				}
				width: 398px;
				margin-bottom: 30px;
				@media ($desktop_only) {
        			width: calc(33.3333333333% - 20px);
        			margin-bottom: 20px;
    			}
			}
			@media ($tablet_paysage){
				.article {
					display: inline-block!important;
					flex: 40vw!important;
					margin-bottom: 0!important;
					margin: 16px 8px!important;

					&:nth-child(odd){
						margin: 16px 12px 16px 8px!important;
					}

					&:nth-child(even){
						margin: 16px 8px 16px 12px!important;
					}

					h2 {
						font-size: 17px!important;
						line-height: 21px!important;
						margin: 16px 20px!important;
					}

					.cover {
						padding-top: 49%!important;
					}
					
				}

				.ghost {
					display: inline-block!important;
					flex: 40vw!important;
					margin-bottom: 0!important;
					margin: 16px 8px!important;
				}
				
			}

			@media ($mobile){
				.article {
					display: inline-block!important;
					flex: 70vw!important;
					margin-bottom: 0!important;
					margin: 10px 10px!important;

					h2 {
						font-size: 17px!important;
						line-height: 21px!important;
						margin: 16px 20px!important;
					}

					.cover {
						padding-top: 49%!important;
					}
					
				}
				.ghost {
					
				}
			}
		}

		&.grid-4 {
				.article{
					width: 291px;
					h2 {
						font-size: 17px;
						line-height: 22px;
					}
			
				}
				.ghost{
					display: none;
				}

				@media ($desktop_only){
					.article{
						width: calc(25% - 20px);
					}
				}
			}

			@media ($tablet_paysage){
				.article {
					display: inline-block!important;
					flex: 40vw!important;
					margin-bottom: 0!important;
					margin: 16px 8px!important;

					h2 {
						font-size: 17px!important;
						line-height: 21px!important;
						margin: 16px 20px!important;
					}

					.cover {
						padding-top: 49%!important;
					}
					
				}
			
			}
			
			@media ($mobile){
				.article {
					display: inline-block!important;
					flex: 70vw!important;
					margin-bottom: 0!important;
					margin: 10px 10px!important;

					h2 {
						font-size: 17px!important;
						line-height: 21px!important;
						margin: 16px 20px!important;
					}

					.cover {
						padding-top: 49%!important;
					}
					
				}
				.ghost {
					display: none;
				}

			}
	}

	.article {
		background: #fff;
		box-sizing: border-box;
		border-radius: 10px;
		display: inline-block;
		overflow: hidden;
		position: relative;

		a {
			height: 100%;
			text-decoration: none;
			display: block;
			padding-bottom: 30px;
		}



		h2 {
			margin: 20px 30px;
			max-height: 65px;
			box-sizing: border-box;
    		overflow: hidden;
		}

		.author {
			position: absolute;
			bottom: 20px;
			left: 30px;
			opacity: 0.6;
			@media ($tablet_paysage){
				left: 21px;
			}
		}

		&:hover {
			transform: scale(1.02);
			transition: all 0.25s;
		}

		.cover {
			background: #79CA0C;
			width: 100%;
			padding-top: 56%;
			background-size: cover;
			background-position:center;
			background-repeat: no-repeat;
		}
	}

	.ghost {
		background: #EBEBEB99;
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/WidgetArticlesRelated.vue